import React from "react";
import { GoArrowUpRight } from "react-icons/go";
import { MdOutlineCalendarToday } from "react-icons/md";
import { CiTimer } from "react-icons/ci";
import { SlLike } from "react-icons/sl";
import { VscTelescope } from "react-icons/vsc";

import PlaceholderBar from "./PlaceholderBar";
import { getDate } from "../utilities/formatTimestamp";
import { useNavigate } from "react-router-dom";

const PostListComponent = ({ data, loading, isDay }) => {
	const navigate = useNavigate();
	function formatLanguage() {
		if (data.language?.length > 1) {
			let text1 = "";
			// eslint-disable-next-line array-callback-return
			data.language.map((lang) => {
				if (data.language.indexOf(lang) === 0) {
					text1 += `${lang}`;
				} else {
					text1 += ` | ${lang}`;
				}
			});

			return text1;
		}
		if (data.language?.length === 1) {
			return `${data.language[0]}`;
		}
	}

	function isWithinDays() {
		const timestampDate = new Date(data?.timestamp?.seconds * 1000);
		const expiryDate = new Date(
			timestampDate.getTime() + +data?.newFor * 24 * 60 * 60 * 1000
		);
		return Date.now() <= expiryDate;
	}

	return (
		<div
			onClick={() => navigate(`/nexus/blog/${data?.id}`)}
			className={`flex flex-col items-start gap-1 mb-3 duration-300 ease-in break-inside-avoid-column p-3 sm:p-5 ${
				isDay ? "border-neutral-300" : "border-neutral-700"
			} border-b-[0.5px]`}>
			{loading ? (
				<>
					<PlaceholderBar classname="w-full h-[10px] placeholder" />
					<PlaceholderBar classname="w-full h-[10px] placeholder" />
					<PlaceholderBar classname="w-full h-[10px] placeholder" />
				</>
			) : (
				<div className="w-full cursor-pointer">
					<div className={`flex flex-row justify-between items-center w-full`}>
						<div>
							<div
								className={`duration-300 ease-in flex flex-row items-center justify-start w-full gap-2 mb-3 text-[10px] font-semibold uppercase tracking-widest ${
									isDay ? "text-teal" : "text-orange-300"
								}`}>
								<span>{formatLanguage(data.language)}</span>
								{isWithinDays() && (
									<span className="px-1 text-white bg-red-500 rounded-sm">
										New
									</span>
								)}
							</div>
							<p className="w-full text-[14px] font-semibold leading-6 tracking-widest">
								{data?.title}
							</p>
						</div>
						<div
							className={`ml-10 duration-300 ease-in text-linesLight hover:text-orange-300`}>
							<GoArrowUpRight size={24} />
						</div>
					</div>
					<div className="flex items-center gap-5 mt-1">
						<div className="flex items-center gap-[5px]">
							<MdOutlineCalendarToday size={10} color="757575" />
							<span className="text-[10px] sm:text-xs text-lines">
								{getDate(data.timestamp, "MMMM YYYY", true)}
							</span>
						</div>
						<div className="flex items-center gap-[5px]">
							<CiTimer size={10} color="757575" />
							<span className="text-[10px] sm:text-xs text-lines">
								{data.readTime} read
							</span>
						</div>
						{data.likes ? (
							<div className="flex items-center gap-[5px]">
								<SlLike size={10} color="757575" />
								<span className="text-[10px] sm:text-xs text-lines">
									{data.likes} {data.likes > 1 ? "likes" : "like"}
								</span>
							</div>
						) : (
							""
						)}
						<div className="flex items-center gap-[5px]">
							<VscTelescope size={10} color="757575" />
							<span className="text-[10px] sm:text-xs text-lines">
								{data?.views} {data?.views > 1 ? "views" : "view"}
							</span>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export { PostListComponent };
export default PostListComponent;
